import React from 'react';
import { TicketIcon, MonitorPlayIcon, MicVocalIcon, CheckCircleIcon } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: <TicketIcon className="w-6 h-6" data-id="element-148" />,
    title: 'Get a Token',
    description: 'Visitors obtain a token for their required service from the front desk.',
    badge: 'Self-service kiosk coming soon'
  }, {
    icon: <MonitorPlayIcon className="w-6 h-6" data-id="element-149" />,
    title: 'Track Progress',
    description: 'Real-time queue progress is displayed on units in the waiting area.'
  }, {
    icon: <MicVocalIcon className="w-6 h-6" data-id="element-150" />,
    title: 'Smart Call',
    description: 'Staff trigger the hybrid announcement, calling the customer by name.'
  }, {
    icon: <CheckCircleIcon className="w-6 h-6" data-id="element-151" />,
    title: 'Get Served',
    description: 'Customer proceeds to the correct department for seamless service.'
  }];
  return <section id="how-it-works" className="py-24 bg-slate-50" data-id="element-152">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-153">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-154">
          <h2 className="text-3xl md:text-4xl font-bold text-heading mb-4" data-id="element-155">
            How It Works
          </h2>
          <p className="text-lg text-slate-600" data-id="element-156">
            A streamlined flow designed to reduce waiting area congestion and
            improve operational efficiency.
          </p>
        </div>

        <div className="grid md:grid-cols-4 gap-8 relative" data-id="element-157">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-slate-200 z-0" data-id="element-158"></div>

          {steps.map((step, index) => <div key={index} className="relative z-10 flex flex-col items-center text-center" data-id="element-159">
              <div className="w-24 h-24 rounded-full bg-white border-4 border-slate-50 shadow-sm flex items-center justify-center mb-6 relative" data-id="element-160">
                <div className="absolute inset-0 rounded-full border border-slate-200" data-id="element-161"></div>
                <div className="w-16 h-16 rounded-full bg-primary/5 flex items-center justify-center text-primary" data-id="element-162">
                  {step.icon}
                </div>
                <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-accent text-white flex items-center justify-center font-bold text-sm shadow-sm" data-id="element-163">
                  {index + 1}
                </div>
              </div>
              <h3 className="text-xl font-bold text-heading mb-3" data-id="element-164">
                {step.title}
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed mb-4" data-id="element-165">
                {step.description}
              </p>
              {step.badge && <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-amber-100 text-amber-800 border border-amber-200" data-id="element-166">
                  {step.badge}
                </span>}
            </div>)}
        </div>
      </div>
    </section>;
}